import React from 'react'
import { Matches } from './Matches'
import { CategoryMatch } from './Matches/CategoryMatch'

interface FindFriendsProps {
  categoryMatches: CategoryMatch[]
}

export const FindFriends = ({
  categoryMatches,
}: FindFriendsProps): JSX.Element => {
  return <Matches categoryMatches={categoryMatches} />
}
